import React from 'react';
import { useFormContext } from 'react-hook-form';
import { EMAIL_REGEX } from '../../../../../constants/regex';
import { Typography } from '../../../../atoms/typography/Typography';
import { Input } from '../../../../atoms/input/Input';
import { Stack } from '../../../../atoms/stack/Stack';
import { Select } from '../../../../atoms/select/Select';
// import RadioQuestion from '../../../shared/radioQuestion/RadioQuestion';

export const ServiceForm = ({
  types,
  selectedTypes,
  choices,
  handlePreviousStep,
  noBackButton,
  t,
}) => {
  const { register, formState } = useFormContext();

  const selectedTypeObj = types.find((type) => type.id === selectedTypes[0]);

  return (
    <Stack className="flex-1 justify-start gap-5 mb-6">
      <div className="flex flex-wrap gap-3 mb-2">
        {selectedTypes.map((el) => (
          <div
            key={`formTypes-${el}`}
            className="py-2 px-3 text-clamp-md font-light bg-customGray-100 text-customGray-900 rounded-xl"
          >
            {selectedTypeObj.title}
          </div>
        ))}
        {!noBackButton && (
          <button
            type="button"
            onClick={handlePreviousStep}
            className="py-2 px-3 ml-2 text-clamp-md font-light border border-customGray-300 rounded-xl global-hover"
          >
            {t('common.back')}
          </button>
        )}
      </div>
      <div>
        <Typography fontVariant="h8" className="w-fit leading-none mb-3">
          {t('formCommon.contactDetails')}
        </Typography>
        <div className="flex flex-col md:flex-row justify-between gap-0 md:gap-5">
          <Input
            borderLabel={t('formCommon.firstName')}
            validationCheckmark
            isDirty={formState.dirtyFields.first_name}
            error={formState.errors.first_name}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...register('first_name', {
              required: true,
              validate: (val) => {
                if (val.length < 2) {
                  return t('formCommon.nameEmpty');
                }
                return true;
              },
            })}
          />
          <Input
            borderLabel={t('formCommon.lastName')}
            validationCheckmark
            isDirty={formState.dirtyFields.last_name}
            error={formState.errors.last_name}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...register('last_name', {
              required: true,
              validate: (val) => {
                if (val.length < 2) {
                  return t('formCommon.nameEmpty');
                }
                return true;
              },
            })}
          />
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-0 md:gap-5">
          <Input
            borderLabel={t('formCommon.company')}
            validationCheckmark
            isDirty={formState.dirtyFields.company}
            error={formState.errors.company}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...register('company', {
              required: true,
              validate: (val) => {
                if (val.length < 2) {
                  return t('formCommon.companyEmpty');
                }
                return true;
              },
            })}
          />
          <Input
            borderLabel={t('formCommon.phoneNumber')}
            validationCheckmark
            isDirty={formState.dirtyFields.phone}
            error={formState.errors.phone}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...register('phone', {
              required: true,
              validate: (val) => {
                if (val.length < 2) {
                  return t('formCommon.phoneEmpty');
                }
                return true;
              },
            })}
          />
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-0 md:gap-5">
          <Input
            borderLabel={t('formCommon.companyEmail')}
            validationCheckmark
            isDirty={formState.dirtyFields.email}
            error={formState.errors.email}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...register('email', {
              required: true,
              pattern: {
                value: EMAIL_REGEX,
                message: t('formCommon.emailIsEmail'),
              },
            })}
          />
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-0 md:gap-5">
          <Input
            multiline
            borderLabel={t('formCommon.other')}
            validationCheckmark
            isDirty={formState.dirtyFields.text}
            error={formState.errors.text}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...register('text', {})}
          />
        </div>
      </div>
      {selectedTypes[0] === 'OFFERREQUEST' && (
        <div>
          <Typography fontVariant="h8" className="w-fit leading-none mb-3">
            {t('formCommon.licenses')}
          </Typography>
          {/* <RadioQuestion
            formName="license_number"
            answers={choices}
            required
            horizontal
          /> */}
          <Select
            data={{ default: t('formCommon.licensesChoose'), items: choices }}
            label="Välj licens"
            error={formState.errors.license_number}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...register('license_number', {})}
          />
        </div>
      )}
    </Stack>
  );
};
